import { render, staticRenderFns } from "./OrderCreatorSummary.vue?vue&type=template&id=2ad12910&scoped=true&"
import script from "./OrderCreatorSummary.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorSummary.vue?vue&type=style&index=0&id=2ad12910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad12910",
  null
  
)

export default component.exports